import axios from 'axios'
import NProgress from 'nprogress'
import { getUserToken } from './auth'

// TODO - Handle error, internet disconnected.

// create a new axios http
const http = axios.create({
  baseURL: process.env.NODE_ENV !== 'production' ? 'https://test.huirep.com/' : 'https://live.huirep.com/'
})

// Here set the header of your ajax library to the token value.
// example with axios
const token = getUserToken()
if (token && token !== null && token !== '') {
  http.defaults.headers.common['user_session_token'] = token
}

// before a request is made start the nprogress
http.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// before a response is returned stop nprogress
http.interceptors.response.use(response => {
  NProgress.done()
  return response
}, error => {
  NProgress.done()
  return Promise.reject(error)
})

// set user session token header
const setHeader = (token) => {
  const header = {}
  token = token || getUserToken()
  header['user_session_token'] = token
  return header
}

const setFormData = data => {
  const formData = new FormData()
  for (const key in data) {
    formData.append(key, data[key])
  }
  return formData
}

const validateResponse = response => {
  if (response.code === 200 && response.data !== null && response.data !== {} && response.data !== [] && response.data.length !== 0 && Object.keys(response.data).length !== 0) {
    return true
  }
  return false
}

export { http, setHeader, setFormData, validateResponse }
